import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2acbf16e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "calendar-view-grid" }
const _hoisted_3 = { class: "calendar-view-grid__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CalendarLegend = _resolveComponent("CalendarLegend")!
  const _component_PriceTable = _resolveComponent("PriceTable")!
  const _component_Error = _resolveComponent("Error")!

  return (!_ctx.showError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Calendar, {
            onShowError: _cache[0] || (_cache[0] = (value) => _ctx.showError = value),
            onErrorMessage: _cache[1] || (_cache[1] = (value) => _ctx.errorMessage = value),
            url: _ctx.url,
            ticketId: "123",
            selectedDateStart: _ctx.selectedDate.start,
            onChangeDateStart: _cache[2] || (_cache[2] = (date) => _ctx.changeDate('start', date)),
            selectedDateEnd: _ctx.selectedDate.end,
            onChangeDateEnd: _cache[3] || (_cache[3] = (date) => _ctx.changeDate('end', date)),
            onChangeDayRange: _cache[4] || (_cache[4] = (number) => _ctx.changeDate('dayRange', number)),
            onChangeDynamicPricing: _cache[5] || (_cache[5] = (bool) => _ctx.changeHasDynamicPricing(bool)),
            onChangeTicketPrices: _ctx.changeTicketPrices,
            onChangeValidation: _cache[6] || (_cache[6] = (bool) => _ctx.changeValidation('calendar', bool)),
            onChangeHasServices: _cache[7] || (_cache[7] = (bool) => _ctx.changeHasServices(bool)),
            onIsLoading: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emit('isLoading', $event))),
            onChangeAvailableTickets: _ctx.changeAvailableTickets
          }, null, 8, ["url", "selectedDateStart", "selectedDateEnd", "onChangeTicketPrices", "onChangeAvailableTickets"]),
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_CalendarLegend, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.translate('shop.ticket.configuration.prices')) + " ", 1),
              _hoisted_4,
              (_ctx.selectedDate.start)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getLocaleDateString(_ctx.selectedDate.start)), 1))
                : _createCommentVNode("", true),
              _createTextVNode(),
              (_ctx.selectedDate.end)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "- " + _toDisplayString(_ctx.getLocaleDateString(_ctx.selectedDate.end)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.translate('shop.ticket.configuration.Select-Date')) + " ", 1),
                    _hoisted_8
                  ]))
            ]),
            _createVNode(_component_PriceTable, {
              isLoading: _ctx.isLoadingPrices,
              ticketPrices: _ctx.ticketPrices,
              priceGroups: _ctx.priceGroups
            }, null, 8, ["isLoading", "ticketPrices", "priceGroups"]),
            (!_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_CalendarLegend, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createVNode(_component_Error, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"])
      ]))
}